var map = {
	"./ava_logo_feher.svg": 6703,
	"./galeria_logo_feher.svg": 9548,
	"./jamh_logo_feher.svg": 9221,
	"./kbmo_logo_feher.svg": 4244,
	"./ktkh_logo_feher.svg": 2053,
	"./pmh_logo_feher.svg": 4808,
	"./szimh_logo_feher.svg": 4712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7791;